import { render, staticRenderFns } from "./EndingValueIndicator.vue?vue&type=template&id=3c5238c5&scoped=true&"
import script from "./EndingValueIndicator.vue?vue&type=script&lang=js&"
export * from "./EndingValueIndicator.vue?vue&type=script&lang=js&"
import style0 from "./EndingValueIndicator.vue?vue&type=style&index=0&id=3c5238c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5238c5",
  null
  
)

export default component.exports